import type { nullable } from "./generated/healthSmall.gen";

// Make a Map into an object so that later JSON.stringify can do the right thing on it
export function convertStringMapToObject(
  map: Map<string | nullable, string | nullable> | nullable
): any {
  if (!map) {
    return undefined;
  }

  const mapAsObject: any = {};

  map.forEach((value: string | nullable, key: string | nullable) => {
    if (key) {
      mapAsObject[key] = value;
    }
  });

  return mapAsObject;
}

export function jsonStringify(obj: any) {
  return JSON.stringify(obj);
}

// Needed to support IE 11 because there is no support for Array.from in IE 11
export function getDedupedArray(array1: string[], array2: string[]): string[] {
  const dedupedArray: string[] = [];

  // IE 11 doesn't support initialization of a new Set via the constructor
  const arraysAsSet = new Set<string>();
  array1.concat(array2).forEach((s) => arraysAsSet.add(s));
  arraysAsSet.forEach((s) => dedupedArray.push(s));

  return dedupedArray;
}
